import * as React from 'react'
import ReactDOM from 'react-dom'

type Props = {
  children: React.ReactNode
}

class Modal extends React.PureComponent<Props> {
  el: HTMLDivElement

  modalRoot: HTMLElement | null | undefined

  constructor(props: Props) {
    super(props)
    this.el = document.createElement('div')
  }

  componentDidMount() {
    this.modalRoot = document.getElementById('modal')
    if (this.modalRoot) {
      this.modalRoot.appendChild(this.el)
    }
  }

  componentWillUnmount() {
    if (this.modalRoot) {
      this.modalRoot.removeChild(this.el)
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el)
  }
}

export default Modal
